"use strict";

var DataSourcedMixin, DataTypeConversionMixin, DisableOnSubmitMixin, HelpMixin, MultiSelectField, React, StandardErrorDisplayMixin, classnames, each, map;

React = require("react");

classnames = require("classnames");

DataSourcedMixin = require("./mixins/DataSourced");

StandardErrorDisplayMixin = require("./mixins/StandardErrorDisplay");

DisableOnSubmitMixin = require("./mixins/DisableOnSubmit");

HelpMixin = require("./mixins/Help");

DataTypeConversionMixin = require("./mixins/DataTypeConversion");

map = require("lodash/map");

each = require("lodash/each");

MultiSelectField = React.createClass({
  displayName: "MultiSelectField",

  mixins: [DataSourcedMixin, StandardErrorDisplayMixin, DisableOnSubmitMixin, HelpMixin, DataTypeConversionMixin],
  propTypes: {
    displayName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.bool]),
    dataKey: React.PropTypes.string.isRequired
  },
  onChange: function onChange(event) {
    var value;
    value = map(event.target.selectedOptions, (function (_this) {
      return function (option) {
        return _this.convertDataType(option.value);
      };
    })(this));
    return this.props.onDataChanged(this.props.dataKey, value);
  },
  render: function render() {
    var classes, label, options, size;
    classes = {
      "form-control": true
    };
    each(this.props.classes, (function (_this) {
      return function (name) {
        return classes[name] = true;
      };
    })(this));
    options = null;
    if (this.state.options instanceof Array) {
      options = map(this.state.options, (function (_this) {
        return function (option, i) {
          var disabled;
          disabled = option.disabled;
          return React.createElement(
            "option",
            { key: i, value: option.value, disabled: disabled },
            option.displayName
          );
        };
      })(this));
    }
    if (this.props.displayName !== false) {
      label = React.createElement(
        "label",
        { className: "col-sm-2 control-label", htmlFor: this.props.dataKey },
        this.props.displayName
      );
    }
    size = this.props.displayName === false ? "col-sm-12" : "col-sm-10";
    return React.createElement(
      "div",
      { className: this.errorClasses("form-group") },
      label,
      React.createElement(
        "div",
        { className: size },
        React.createElement(
          "select",
          {
            multiple: true,
            onChange: this.onChange,
            className: classnames(classes),
            name: this.props.dataKey,
            value: this.props.data,
            disabled: this.disabled()
          },
          options
        ),
        this.errorSpan(),
        this.helpSpan()
      )
    );
  }
});

module.exports = MultiSelectField;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/MultiSelect.js
 ** module id = 550
 ** module chunks = 0
 **/